import React from "react";
import { Tree } from "primereact/tree";
import { keysFromSelection, selectionFromKeys } from "../utils/features";

// Module picker for an organization's plan. Ticking a module includes
// everything under it; "Select all" / "Clear" act on the whole tree so staff
// never have to untick modules one by one. The summary line says what will be
// saved, in plain words.
export default function FeaturePicker({ tree, selection, onChange, disabled = false, comingSoon = [] }) {
  const keys = keysFromSelection(tree, selection);
  const everything = keys.includes("All");
  const count = keys.length;

  const selectAll = () => onChange(selectionFromKeys(tree, ["All"]));
  const clear = () => onChange({});

  let summary;
  if (everything) summary = "Everything is included.";
  else if (count === 0) summary = "Nothing selected — pick at least one module.";
  else summary = `${count} module${count === 1 ? "" : "s"} included (ticking a module includes everything under it).`;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, marginBottom: 6 }}>
        <small style={{ color: count === 0 ? "#CC2229" : "#5b6a65" }}>{summary}</small>
        <div style={{ display: "flex", gap: 6 }}>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={selectAll} disabled={disabled || everything} style={{ borderRadius: 8 }}>
            Select all
          </button>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={clear} disabled={disabled || count === 0} style={{ borderRadius: 8 }}>
            Clear
          </button>
        </div>
      </div>
      <Tree
        value={tree}
        selectionMode="checkbox"
        selectionKeys={selection}
        onSelectionChange={(e) => onChange(e.value)}
        disabled={disabled}
        className="w-full"
        style={{ maxHeight: 340, overflow: "auto" }}
      />
      {comingSoon.length > 0 && (
        <small style={{ display: "block", marginTop: 6, color: "#8a9591" }}>
          Coming soon (not offered yet): {comingSoon.join(", ")}.
        </small>
      )}
    </div>
  );
}
